<template>
  <div class="big healthCareCard-details">
    <div class="page_title flex_between">
      <span>养生卡详情</span>
      <el-button type="primary" style="width: 120px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <div class="top-title">
          <el-button type="primary"></el-button>购买用户
        </div>
        <div class="healthCareCard-info">
          <div class="info-item">
            <div class="item">
              <div class="label">用户昵称</div>
              <div class="value">{{ healthCareCardInfo.nick_name }}</div>
            </div>
            <div class="item">
              <div class="label">用户手机号</div>
              <div class="value">{{ healthCareCardInfo.phone }}</div>
            </div>
          </div>
          <div class="info-item">
            <div class="item">
              <div class="label">购买时间</div>
              <div class="value">
                {{ healthCareCardInfo.buy_time | dateFormat }}
              </div>
            </div>
            <div class="item">
              <div class="label">到期时间</div>
              <div class="value">
                <span style="margin-right: 10px">{{
                  healthCareCardInfo.expire_time | dateFormat
                }}</span>
                <el-tag
                  v-if="healthCareCardInfo.is_expire"
                  type="danger"
                  size="small"
                  >已到期</el-tag
                >
              </div>
            </div>
            <div class="item">
              <div class="label">当前购买次数</div>
              <div class="value">{{ healthCareCardInfo.buy_times }}</div>
            </div>
            <div class="item">
              <div class="label">养生卡权益商品</div>
              <div class="value">
                {{ healthCareCardInfo.goods_name }}
                <el-tag
                  v-if="healthCareCardInfo.exchange_order_id > 0"
                  type="danger"
                  >已领取</el-tag
                >
              </div>
            </div>
          </div>
          <div class="info-item">
            <div class="item">
              <div class="label">诊疗优惠金额</div>
              <div class="value">
                {{ healthCareCardInfo.drug_discount_price }}
              </div>
            </div>
            <div class="item">
              <div class="label">商城优惠金额</div>
              <div class="value">
                {{ healthCareCardInfo.goods_discount_price }}
              </div>
            </div>
            <div class="item">
              <div class="label">处方订单积分福利</div>
              <div class="value">{{ healthCareCardInfo.order_integral }}</div>
            </div>
            <div class="item">
              <div class="label">咨询订单积分福利</div>
              <div class="value">{{ healthCareCardInfo.integral }}</div>
            </div>
          </div>
        </div>

        <div class="top-title">
          <el-button type="primary"></el-button>优惠券使用状态
        </div>

        <el-tabs v-model="activeName" @tab-click="handleTabClick">
          <el-tab-pane label="订单状态" name="1"></el-tab-pane>
          <el-tab-pane label="优惠券状态" name="2"></el-tab-pane>
        </el-tabs>

        <template v-if="activeName == 1">
          <div class="search-box">
            <!-- 类型 -->
            <div class="item">
              <span style="margin-left: 10px">类型</span>
              <div class="item-content">
                <el-select
                  v-model="healthCareCardDetailsForm.order_type"
                  size="small"
                  clearable
                  @change="getList"
                >
                  <el-option label="处方订单" :value="1"></el-option>
                  <el-option label="商城订单" :value="2"></el-option>
                </el-select>
              </div>
              <el-button
                type="primary"
                size="small"
                style="margin-left: 20px"
                @click="getList"
                >查询</el-button
              >
              <el-button size="small" @click="restBtn">重置</el-button>
            </div>
          </div>

          <div style="border: solid 1px #c9cbd6">
            <el-table
              v-loading="tableLoading"
              :data="healthCareCardData"
              tooltip-effect="dark"
              style="width: 100%; min-width: 1000px"
              :header-cell-style="{ background: '#F5F5F5' }"
            >
              <el-table-column
                v-for="item in tableHeader"
                :key="item.prop"
                :prop="item.prop"
                :label="item.label"
                :width="item.width"
                :fixed="item.fixed"
              >
                <template slot-scope="scope">
                  <div v-if="item.prop == 'order_type'">
                    {{ scope.row[item.prop] | orderTypeText }}
                  </div>
                  <div v-else-if="item.prop == 'pay_time'">
                    {{ scope.row[item.prop] | dateFormat }}
                  </div>
                  <div v-else-if="item.prop == 'order_status'">
                    {{ scope.row[item.prop] | orderStatusText }}
                  </div>
                  <div v-else>
                    {{
                      JSON.stringify(scope.row[item.prop]) === "null"
                        ? ""
                        : scope.row[item.prop]
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row['order_type'] == 1"
                    type="text"
                    size="medium"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('115')
                        : false
                    "
                    @click="toDetail(scope.row)"
                    >查看详情</el-button
                  >
                  <el-button
                    v-if="scope.row['order_type'] == 2"
                    type="text"
                    size="medium"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('788')
                        : false
                    "
                    @click="toDetail(scope.row)"
                    >查看详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <pagination
            v-show="totalNum > 0"
            :total="totalNum"
            :page.sync="pagination.page"
            :limit.sync="pagination.pageNumber"
            @pagination="getList"
          />
        </template>

        <template v-else>
          <div class="search-box">
            <!-- 类型 -->
            <div class="item">
              <span style="margin-left: 10px">类型</span>
              <div class="item-content">
                <el-select
                  v-model="couponForm.coupon_from"
                  size="small"
                  @change="getCouponList"
                >
                  <el-option label="诊疗优惠券" :value="1"></el-option>
                  <el-option label="商城优惠券" :value="2"></el-option>
                </el-select>
              </div>
              <el-button
                type="primary"
                size="small"
                style="margin-left: 20px"
                @click="getCouponList"
                >查询</el-button
              >
              <el-button size="small" @click="couponFormRestBtn"
                >重置</el-button
              >
            </div>
          </div>

          <div style="border: solid 1px #c9cbd6">
            <el-table
              v-loading="tableLoading"
              :data="couponData"
              tooltip-effect="dark"
              style="width: 100%; min-width: 1000px"
              :header-cell-style="{ background: '#F5F5F5' }"
            >
              <el-table-column
                v-for="item in couponTableHeader"
                :key="item.prop"
                :prop="item.prop"
                :label="item.label"
                :width="item.width"
                :fixed="item.fixed"
              >
                <template slot-scope="scope">
                  <div v-if="item.prop == 'coupon_from'">
                    {{
                      scope.row[item.prop] == 1 ? "诊疗优惠劵" : "商城优惠券"
                    }}
                  </div>
                  <div v-else-if="item.prop == 'used'">
                    {{ scope.row[item.prop] == 1 ? "已使用" : "未使用" }}
                  </div>
                  <div v-else-if="item.prop == 'user_info'">
                    <div>{{ scope.row["nick_name"] }}</div>
                    <div>{{ scope.row["phone"] }}</div>
                  </div>
                  <div v-else-if="item.prop == 'times'">
                    <div>
                      {{
                        (scope.row["receive_status"] == 1
                          ? scope.row["receive_time"]
                          : scope.row["get_time"]) | dateFormat
                      }}
                    </div>
                  </div>
                  <div v-else>
                    {{
                      JSON.stringify(scope.row[item.prop]) === "null"
                        ? ""
                        : scope.row[item.prop]
                    }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import marketing from "@/api/marketing.js";
import Pagination from "@/components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      activeName: "1",
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      healthCareCardDetailsForm: {
        order_type: "",
      },
      tableHeader: [
        {
          label: "订单号",
          prop: "order_sn",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "类型",
          prop: "order_type",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "支付时间",
          prop: "pay_time",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "优惠后订单金额",
          prop: "order_price",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "优惠金额",
          prop: "discount_price",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "订单状态",
          prop: "order_status",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "积分福利",
          prop: "integral",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      healthCareCardInfo: {
        nick_name: "",
        phone: "",
        buy_time: "",
        expire_time: "",
        buy_times: "",
        drug_discount_price: "",
        goods_discount_price: "",
        integral: "",
        order_integral: "",
        is_expire: false,
      },
      healthCareCardData: [],
      couponForm: {
        coupon_from: 1,
      },
      couponTableHeader: [
        {
          label: "优惠券名称",
          prop: "coupon_name",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "使用条件",
          prop: "use_condition",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "类型",
          prop: "coupon_from",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "状态",
          prop: "used",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "所在用户",
          prop: "user_info",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "领取/获取时间",
          prop: "times",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      couponData: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
    orderTypeText(val) {
      switch (val) {
        case 1:
          return "处方订单";
        case 2:
          return "商城订单";
      }
    },
    orderStatusText(val) {
      switch (val) {
        case 0:
          return "待发货";
        case 1:
          return "待收货";
        case 2:
          return "已完成";
        case 3:
          return "待付款";
        case 4:
          return "已取消[不通过]";
        case 5:
          return "已取消[平台退款]";
        case 7:
          return "已取消[用户退款]";
        case 8:
          return "已取消[超时未支付]";
        case 9:
          return "已取消[用户取消]";
        case 10:
          return "已取消[超时未发货]";
        case 11:
          return "用户申请退款";
        case 12:
          return "异常订单";
        case 13:
          return "售后/退款";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    routeQuery() {
      return this.$route.query;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = Object.assign(
        {},
        this.pagination,
        this.healthCareCardDetailsForm,
        {
          log_id: this.routeQuery.log_id,
        }
      );
      this.tableLoading = true;
      marketing
        .getUserOrderListPaging(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.healthCareCardInfo = data.info;
            this.healthCareCardInfo.is_expire =
              dayjs(new Date()).unix() > data.info.expire_time;
            this.healthCareCardData = data.list;
            this.totalNum = data.total;
            this.tableLoading = false;
          }
        })
        .catch((err) => {});
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    restBtn() {
      this.healthCareCardDetailsForm.order_type = "";
      this.getList();
    },
    back() {
      history.back();
    },
    toDetail(row) {
      let { order_type, order_id } = row;
      let path = "";
      switch (order_type) {
        case 1:
          path = "/home/order/orderdetail";
          break;
        case 2:
          path = "/home/shoppingmall/orderdetail";
          break;
      }
      this.$router.push({
        path,
        query: {
          order_id,
        },
      });
    },
    // 切换tab
    handleTabClick(tab, e) {
      this.activeName == 2 ? this.getCouponList() : this.getList();
    },
    // 优惠券使用状态 --- start
    getCouponList() {
      let params = Object.assign({}, this.couponForm, {
        log_id: this.routeQuery.log_id,
      });
      this.tableLoading = true;
      marketing
        .getUserCoupon(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.couponData = data.list;
            this.tableLoading = false;
          }
        })
        .catch((err) => {});
    },
    couponFormRestBtn() {
      this.couponForm.coupon_from = 1;
      this.getCouponList();
    },
    // --- end
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.healthCareCard-details {
  .top-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    margin-top: 10px;
    margin-bottom: 20px;
    .el-button {
      padding: 12px 2px;
      border-radius: 0;
      margin-right: 4px;
    }
  }
  .doctor-info {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .item {
      margin-right: 30px;
      .title {
        width: 100px;
      }
    }
  }
  .healthCareCard-info {
    height: 100px;
    box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin-bottom: 20px;
    .info-item {
      display: flex;
      align-items: center;
      .item {
        display: flex;
        align-items: center;
        margin-left: 20px;
        .label {
          font-weight: bold;
        }
        .value {
          margin-left: 10px;
        }
      }
    }
  }
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
  .statistics-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .box-card {
      width: 30%;
      ::v-deep .el-card__body {
        display: flex;
        align-items: center;
        justify-content: space-around;
        img {
          width: 80px;
          height: 80px;
        }
        .desc {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .value {
            font-size: 20px;
            font-weight: bold;
          }
          .title {
            padding: 10px 0;
          }
        }
      }
    }
  }
}
.benevolence-details-dia {
  .el-form {
    padding-top: 10px;
    padding-left: 20px;
    .el-form-item {
      display: flex;
      align-items: center;
    }
    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .el-date-editor {
    width: 400px;
  }
  .el-select {
    width: 400px;
  }
  .el-input-number {
    width: 400px;
    ::v-deep .el-input__inner {
      text-align: left;
    }
  }
  .el-textarea {
    width: 400px;
  }
  .prompt {
    font-size: 12px;
    text-align: left;
    color: red;
    padding-left: 10px;
    margin-bottom: 0;
    height: auto;
  }
}
</style>
